module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/um-c3e06b4d7dfec14653ce49da7ac9efe4.svg";